import { render, staticRenderFns } from "./save_view.vue?vue&type=template&id=25a19d6e&scoped=true"
import script from "./save_view.vue?vue&type=script&lang=js"
export * from "./save_view.vue?vue&type=script&lang=js"
import style0 from "./save_view.vue?vue&type=style&index=0&id=25a19d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a19d6e",
  null
  
)

export default component.exports